export default class LangSwitch {
   constructor(element) {
		this.selectEl = element;

		this.selectEl.addEventListener('change', (e) => window.location = this.selectEl.value)
   }
}
